import Chart from '../VerticalBarChart/chart';
import PDFMakeChartConverter from './PDFMakeChartConverter';

export default async (node, options) => {
  const chart = new Chart();
  const chartConvertor = new PDFMakeChartConverter(chart);

  options.chartOptions = {
    primaryColour: node.meta.primaryBarColour,
    highlightColour: node.meta.highlightBarColour,
    meanLineColour: node.meta.meanLineColour,
    axisLabels: node.meta.axisLabels,
    animate: false,
    groupAverage: node.meta.groupAverage,
    scoreCutoff: node.meta.scoreCutoff,
  };

  return chartConvertor.convert(node, options);
};
